var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cancellation-policy" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v(
        "\n        " + _vm._s(_vm.voMsg("tpl.cancellation.title")) + "\n    "
      )
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "tick-li" }, [
      _vm.showGeneral
        ? _c("li", [
            _c("span", { staticClass: "li-title" }, [
              _vm._v(_vm._s(_vm.voMsg("tpl.cancellation.freeCancellation")))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(_vm._s(_vm.localizedText))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showDate
        ? _c("li", [
            _c("span", { staticClass: "li-title" }, [
              _vm._v(_vm._s(_vm.voMsg("tpl.cancellation.freeCancellation")))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(_vm._s(_vm.localizedText))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _vm._m(5)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("span", { staticClass: "li-title" }, [
        _vm._v("Bestpreis über unsere Website")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("span", { staticClass: "li-title" }, [
        _vm._v("Einfache Onlinebuchung")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("span", { staticClass: "li-title" }, [
        _vm._v("WLAN bei allen Domizilen")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("span", { staticClass: "li-title" }, [
        _vm._v("Bettwäsche & Handtücher")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("span", { staticClass: "li-title" }, [
        _vm._v("Küchenerstausstattung inklusive")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("span", { staticClass: "li-title" }, [_vm._v("Flexible Anreise")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }